import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PublicApp from './PublicApp';

// Add this near the top of your entry file
window.DEBUG_MODE = false; // Set to true only when needed

// Disable console logging in production
if (process.env.NODE_ENV === 'production' || !window.DEBUG_MODE) {
  const noop = () => {};
  const preserveLogs = ['error', 'warn', 'info'];
  
  // Store original console methods
  const originalConsole = { ...console };
  
  // Replace console methods with no-ops selectively
  Object.keys(console).forEach(method => {
    if (typeof console[method] === 'function' && !preserveLogs.includes(method)) {
      console[method] = noop;
    }
  });
  
  // Add ability to restore console
  window.restoreConsole = () => {
    Object.assign(console, originalConsole);
    console.log('Console restored');
  };
}

// Determine if this is a public invitation view
const path = window.location.pathname;
const isPublicInvitation = path.split('/').length === 4 && !path.includes('/events/');

console.log('🔴 index.js is loading');
console.log('🔴 Current path:', path);
console.log('🔴 Using:', isPublicInvitation ? 'PublicApp' : 'App');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isPublicInvitation ? <PublicApp /> : <App />}
  </React.StrictMode>
); 